import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

export const AdvocateStepHeading: React.FC<Props> = ({ title, subtitle, className, titleClassName }) => {
	return (
		<div className={cn('space-y-4 text-balance text-center', className)}>
			<Text
				as="h1"
				className={cn('mx-0 block text-typography-strong', titleClassName)}
				variant="heading"
				size="x-large"
			>
				{title}
			</Text>

			{subtitle && <Text className="block text-typography-weak">{subtitle}</Text>}
		</div>
	);
};

type Props = {
	title: string;
	subtitle?: string | React.ReactNode;
	className?: string;
	titleClassName?: string;
};
